import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	"aria-hidden": "true",
	focusable: "false",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M0 5v2h8.172l-2.95 2.95 1.414 1.414L12 6 6.636.636 5.222 2.05 8.172 5H0Z" })
});
export default SvgArrowRight;
